import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {
    EditPaymentMethodStart,
    EditPaymentMethodSuccess,
    EditPaymentMethodError,
    EditPaymentMethodInitial
} from '../actions/edit-payment-methods';
import {
    IEditPaymentRequestPayload,
    IEditPaymentMethodResponse
} from '../state/edit-payment-methods';
import { Http } from '@telstra-connect/utils';
import { getRequestIdForAlerts } from '@telstra-connect/utils/http/common/headers';
import api from '../version';

export function editPaymentMethodDetails(body?: IEditPaymentRequestPayload, accountId?: string, cidn?: string, tid?: string):
ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch, getState) => {
        dispatch(EditPaymentMethodStart());
        if (body) {
            const appendHeader = Http.put<IEditPaymentMethodResponse, IEditPaymentRequestPayload>({
                url: `/billing/${api.version}/account/${accountId}/`
                    + `editPaymentMethod/${tid}`,
                state: getState(),
                customHeaders: {
                    'company-id': cidn,
                    'request-id': getRequestIdForAlerts(cidn)
                },
                body
            });
            return appendHeader.then((result) => {
                const response: IEditPaymentMethodResponse = result;
                dispatch(EditPaymentMethodSuccess(response));
            })
                .catch((error) => {
                    dispatch(EditPaymentMethodError('Error loading update direct debit detail.', error.code));
                });
        } else {
            dispatch(EditPaymentMethodInitial());
        }
    };
}
